import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import Store from "./redux/Store";
import { BrowserRouter as Router } from "react-router-dom";
import { pwa_modal } from "./redux/Login/LoginActionCreators";
if (localStorage.pwa === undefined) {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    Store.dispatch(pwa_modal({ mode: true, event: e }));
  });
  window.addEventListener("appinstalled", (e) => {
    e.preventDefault();
    Store.dispatch(pwa_modal({ mode: false, event: {} }));
  });
}
ReactDOM.render(
  <Router>
    <Provider store={Store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById("root")
);
